import styled from 'styled-components';

const coverSize = '100%';
const overlayContentPaddingTopBottom = '8px';
const overlayContentPaddingLeftRight = '16px';
const transitionDuration = '0.5s';
const titleLineHeight = '24px';
const subtitleLineHeight = '24px';

const Overlay = styled.div`
  position: absolute;
  bottom: calc(${subtitleLineHeight} + 4px + ${titleLineHeight} + 4px - ${coverSize});
  transition: ${transitionDuration} ease;
  height: 100%;
  max-height: 100%;
  width: 100%;
  padding: ${overlayContentPaddingTopBottom} ${overlayContentPaddingLeftRight};
  transition: ${transitionDuration} ease;
  background: rgba(0, 0, 0, 0.7);
  overflow: hidden;
`;

const Container = styled.div`
  position: relative;
  overflow: hidden;
  cursor: pointer;
  width: ${coverSize};
  height: ${coverSize};
  max-height: ${coverSize};
  max-width: ${coverSize};

  &:hover ${Overlay} {
    bottom: calc(${overlayContentPaddingTopBottom} * -2);
    background: rgba(0, 0, 0, 0.9);
    transition: all ${transitionDuration} ease;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: ${coverSize};
  padding-bottom: 100%;
`;

const Subtitle = styled.div`
  font-size: ${props => props.theme.typography.fontSize.m};
  min-height: ${subtitleLineHeight};
  width: calc(${coverSize} - ${overlayContentPaddingLeftRight} * 2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: ${props => props.theme.typography.fontSize.m};
  min-height: ${titleLineHeight};
  width: calc(${coverSize} - ${overlayContentPaddingLeftRight} * 2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Info = styled.div`
  font-size: ${props => props.theme.typography.fontSize.s};
  overflow: hidden;
`;

export default {
  Container,
  Overlay,
  Content,
  Subtitle,
  Title,
  Info,
};
